"use client";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  getPhoneCountryOptionFromValue,
  normalizePhoneInput,
  PHONE_COUNTRY_OPTIONS,
  type PhoneCountryOption,
} from "@/lib/phone-number";

export type PaymentContactInputProps = {
  country: PhoneCountryOption;
  value: string;
  id?: string;
  onCountryChange: (country: PhoneCountryOption) => void;
  onValueChange: (value: string) => void;
};

export function PaymentContactInput({
  country,
  value,
  id,
  onCountryChange,
  onValueChange,
}: PaymentContactInputProps) {
  return (
    <div className="flex gap-2">
      <Select
        value={country.country}
        onValueChange={(countryCode) =>
          onCountryChange(getPhoneCountryOptionFromValue(countryCode))
        }
      >
        <SelectTrigger className="!h-11 min-h-11 w-[94px] rounded-xl border-border bg-surface-alt px-2.5 py-0 pr-7 text-sm font-semibold text-text-primary shadow-none hover:bg-surface-elevated focus:ring-brand/20 dark:border-white/[0.12] dark:bg-glass-bg-06 dark:text-white dark:hover:bg-glass-bg-08 dark:focus:ring-white/20">
          <SelectValue>
            <span className="flex items-center gap-1.5">
              <span aria-hidden="true">{country.flag}</span>
              <span>+{country.callingCode}</span>
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-[320px] border-border bg-popover text-popover-foreground dark:border-white/[0.12] dark:bg-[#18181c] dark:text-white">
          {PHONE_COUNTRY_OPTIONS.map((option) => (
            <SelectItem
              key={option.country}
              value={option.country}
              className="text-text-primary focus:bg-surface-alt focus:text-text-primary dark:text-white dark:focus:bg-glass-bg-08 dark:focus:text-white"
            >
              <span>{option.flag}</span>
              <span>+{option.callingCode}</span>
              <span className="text-text-tertiary dark:text-white/55">
                {option.label}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <input
        id={id}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        value={value}
        onChange={(event) =>
          onValueChange(normalizePhoneInput(event.target.value))
        }
        placeholder="Mobile number"
        className="h-11 min-w-0 flex-1 rounded-xl border border-border bg-surface-alt px-3 text-base font-medium text-text-primary outline-none placeholder:text-text-tertiary focus:border-brand md:text-sm dark:border-white/[0.12] dark:bg-glass-bg-06 dark:text-white dark:placeholder:text-white/38 dark:focus:border-white/35"
      />
    </div>
  );
}
